export default function vendorSelection(this) {
  this.$root.$on('vendorSelection', (vendor) => {
    this.data_repair.objects[0].vendor = vendor.name.trim();
  });
}
